export const SET_SELECT_ICONS = 'set_select_icons';

export const SET_CHARACTER_API_DATA = 'set_character_api_data';
export const SET_CURRENT_CHARACTER = 'set_current_character';

export const SET_DARKEN = 'set_darken';
export const SET_MC_DATA = 'set_mc_data';
export const UPDATE_MC_DATA = 'update_mc_data';
export const UPDATE_MC_LOADING = 'update_mc_loading';
export const UPDATE_API_DATA_LOADING = 'update_api_data_loading';
